import { makeStyles } from '@material-ui/core'
import styled from 'styled-components'

export const TableContainer = styled.div`
  width: 100%;
  overflow: auto;
  position: relative;
  background-color: #FFFF;
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
`
export const Table = styled.table`
  font-family: OpenSansRegular;
  border-collapse: collapse;
  width: 100%;
  table-layout: auto;
  position: relative;
`
export const TableRow = styled.tr`
  padding: 8px;
  background: ${({ checked, bgColor = 'transparent' }) => checked ? 'linear-gradient(0deg, rgba(146, 64, 201, 0.16), rgba(146, 64, 201, 0.16)), #FFFFFF !important' : bgColor};
  &:nth-child(odd){
    background: #F2F4F9;
  }
  display: ${({show=true}) => show ? '' : 'none'}
  /* &:hover{
    background-color: #ddd;;
  } */
`
export const TableRowHeader = styled.tr`
  background: #F9F9F9;
  box-shadow: 0px 3px 6px rgba(26, 26, 26, 0.12), 0px 0px 1px rgba(26, 26, 26, 0.24);
  padding: 8px;
  color: #58595B;
`
export const TH = styled.th`
  font-family: OpenSansRegular;
  font-style: normal;
  font-size: 15px;
  padding: 18px 12px;
  box-shadow: 0px 6px 6px -6px rgba(26, 26, 26, 0.12),
              0px 0px 1px -2px rgba(26, 26, 26, 0.24);
  background: #F9F9F9;
  position: sticky;
  top: 0;
  z-index: 9;
`
export const InfoIcon = styled.img`
  margin-left: .5em;
  /* margin-left: .5em; */
  width: 1em;
  height: 1em;
`
export const THContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const TD = styled.td`
  padding: 18px 12px;
  color: #333333;
  font-family: OpenSansRegular;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: 0.005em;
  transition: all 200ms ease-in-out;
  &:hover{
    font-family: ${({ isHoverable }) => isHoverable ? 'OpenSansSemibold' : 'OpenSansRegular'};
  }
`
export const TDContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;
  font-size: .9rem;
`
export const ImageCell = styled.img`
  height: 1.5em;
  width: auto;
  margin-right: .5em;
`
export const TableFooter = styled.div`
  background-color: #FFFFFF;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 5em;
  width: 100%;
  padding: 1em 2em;
  flex-wrap: wrap;
  @media screen and (max-width: 425px) {
    /* flex-direction: column; */
    height: auto;
    padding: .5em .5em;
    & div {
      &:nth-child(1){
        margin-bottom: .5em
      };
      &:nth-child(2){
        margin-bottom: .5em;
        margin: 0 auto .2em auto;
      }
    }
  }
`
export const TotalElementCont = styled.div`
  display: flex;
  flex-direction: row;
  & span{
    font-family: OpenSansRegular;
    font-style: normal;
    font-size: 13px;
    line-height: 18px;
    /* identical to box height */
    display: flex;
    align-items: center;
    letter-spacing: 0.005em;
    /* Textos / Terciario */
    color: #A0A2A6;
    &:first-child{
      font-family: OpenSansSemiBold;
      margin-right: .5em;
    }
  }
`
export const PaginationContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`
export const DoubleArrowImg = styled.img`
  width: 1.5em;
  height: auto;
  cursor: pointer;
  margin: 0 .2em;
`
export const ArrowContainer = styled.div`
  /* Auto Layout */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 2px;
  width: 24px;
  height: 24px;
  /* Ripley / Morado */
  background: #9240C9;
  border-radius: 28px;
  margin: 0 .2em;
  cursor: pointer;
`
export const PageNumbers = styled.div`
  display: flex;
  align-items: center;
`
export const NumberPage = styled.span`
  font-family: ${ ({ active }) => active ? 'OpenSansBold' : 'OpenSansRegular'};
  margin: 0 .7em;
  cursor: pointer;
`
export const ShowElementCont = styled.div`
  display: flex;
  flex-direction: row;
  & span{
    font-family: OpenSansRegular;
    font-style: normal;
    font-size: 13px;
    line-height: 18px;
    /* identical to box height */
    display: flex;
    align-items: center;
    letter-spacing: 0.005em;
    /* Textos / Terciario */
    color: #A0A2A6;
  }
`
export const useInputStyles = makeStyles(theme => ({
  root: {
    minWidth: '.2em',
    maxWidth: '2.2em',
    height: '2em',
    margin: '0 .5em',
    '& input': {
      padding: '7px 4px 4px',
      textAlign: 'center'
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: '#dcdcdc',
      '&$focused': {
        borderColor: 'red'
      }
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: '#9240C9',
      borderWidth: '.5px'
    }
  },
  focused: {}
}));
export const IconFileContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  width: 36px;
  height: 36px;
  /* Fondos / Principal */
  background: #F9F9F9;
  /* Sombras / Secundaria */
  box-shadow: 0px 3px 6px rgba(26, 26, 26, 0.12), 0px 0px 1px rgba(26, 26, 26, 0.24);
  border-radius: 40px;
  cursor: pointer;
`
export const FileTypeImg = styled.img`
  height: 1.4em;
  width: auto;
`
// export const CheckboxImg = styled.img`
//   height: 1.7em;
//   width: 1.7em;
//   cursor: pointer;
// `

export const CheckboxImg = styled.img`
  height: 1.7em;
  width: 1.7em;
  cursor: ${({disabled=false}) => {
    return disabled ? 'auto': 'pointer'
  }};
`
